import { render, staticRenderFns } from "./listFormulaPadrao.vue?vue&type=template&id=5c59ff0e"
import script from "./listFormulaPadrao.ts?vue&type=script&lang=js&external"
export * from "./listFormulaPadrao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c59ff0e')) {
      api.createRecord('5c59ff0e', component.options)
    } else {
      api.reload('5c59ff0e', component.options)
    }
    module.hot.accept("./listFormulaPadrao.vue?vue&type=template&id=5c59ff0e", function () {
      api.rerender('5c59ff0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacao/listFormulaPadrao.vue"
export default component.exports